import React from 'react';
import { useParams } from 'react-router-dom';

import { CheckoutProvider } from './checkoutState';
import { Checkout } from './organisms';

export function CheckoutPage() {
  const { orderId } = useParams();

  return (
    <CheckoutProvider {...{ orderId }}>
      <Checkout {...{ orderId }} />
    </CheckoutProvider>
  );
}
